import React, {ReactElement} from 'react';
import {DeviceType} from '../../../incase-domain/common/DeviceType.enum';
import {IFormElement} from '../../../incase-domain/elements/base/formElementBase';
import {IElementForm} from '../../../incase-domain/elements/form';
import ElementTyped from '../element.typed';

interface FormElementComponentProps {
    element: IElementForm;
    device?: DeviceType;
}

function FormElementComponent(props: FormElementComponentProps): ReactElement {
    const {element, device = DeviceType.DESKTOP} = props;

    const getChildWidth = (childElement: IFormElement): string => {
        return `${(childElement.formWidth || 1) * 100}%`;
    };

    const getChildPadding = (childElement: IFormElement): string => {
        return `${childElement.paddingBefore || 0}em`;
    };

    const getChildStyle = (childElement: IFormElement): {width: string; paddingLeft: string} => ({
        width: getChildWidth(childElement),
        paddingLeft: getChildPadding(childElement),
    });

    return (
        <div className="c-field is-lg">
            <div className="e-label" style={getElementStyle(device, element)}>
                {element.title}
            </div>
            <form action={element.submitUrl} method={element.method} target={element.target || '_blank'}>
                <div className="u-flex flex-wrap">
                    {element.fieldElements
                        .sort((a, b) => {
                            if (a.type === 'BUTTON') return 1;
                            if (b.type === 'BUTTON') return -1;
                            return 0;
                        })
                        .map((childElement, index) => (
                            <div className="u-mt-2" style={getChildStyle(childElement)} key={`${element.id}-form-child-element-${index}`}>
                                <ElementTyped element={childElement} device={device} />
                            </div>
                        ))}
                </div>
            </form>
        </div>
    );
}

function getElementStyle(device: DeviceType, element: IElementForm): React.CSSProperties {
    if (device === DeviceType.MOBILE) {
        return {fontFamily: element.fontFamily?.name};
    }

    return {fontSize: `${element.fontSize || 2}em`, fontFamily: element.fontFamily?.name};
}

export default FormElementComponent;
